import type { ReactNode } from 'react';
import type {
  PopoverColor,
  PopoverItemProps,
} from '../../../Popover/PopoverItem/PopoverItem';

import { use } from 'react';
import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../../lib/helpers';

import PopoverItem from '../../../Popover/PopoverItem/PopoverItem';
import { TopbarContext } from '../../Topbar';

export interface TopbarActionButtonProps {
  /**
   * If action is disallowed
   */
  actionDisallowed?: boolean;
  /**
   * Tooltip text
   */
  tooltip?: string;
  /**
   * Button color
   */
  color?: PopoverColor;
  /**
   * Button label
   */
  label?: ReactNode;
  /**
   * If button is disabled
   */
  disabled?: boolean;
  /**
   * Test id suffix for button
   */
  testIdSuffix?: string;
}

const TopbarActionButton = ({
  color,
  label = '',
  disabled = false,
  actionDisallowed,
  tooltip,
  testIdSuffix,
  ...props
}: TopbarActionButtonProps & PopoverItemProps) => {
  const { t } = useTranslation();
  const { buttonsDisabled, testId } = use(TopbarContext);
  const isDisabled = disabled || buttonsDisabled;

  return (
    <PopoverItem
      label={label}
      disabled={actionDisallowed || isDisabled}
      color={color || 'blue'}
      tooltip={actionDisallowed ? t('UserRoles.CannotPerformAction') : tooltip}
      {...props}
      {...getTestProps(testId, `${testIdSuffix || label}-action`, 'testId')}
    />
  );
};

export default TopbarActionButton;
